import { AxiosInterceptorManager, InternalAxiosRequestConfig } from 'axios';

import { getUniqueId } from 'shared/lib/utils/getUniqueId';

export const xRequestIdInterceptor = (
  manager: AxiosInterceptorManager<InternalAxiosRequestConfig>,
) =>
  manager.use((res) => {
    res.headers['x-request-id'] = getUniqueId();
    return res;
  });
